import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  private apiUrl = 'https://restcountries.com/v3.1/';

  constructor(private http: HttpClient) { }

  getCountries(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}all`);
  }

  getStates(countryCode: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}alpha/${countryCode}`);
  }

  

  // getCities(geonameId: string): Observable<any> {
  //   return this.http.get<any>(`${this.apiUrl}childrenJSON?geonameId=${geonameId}&username=demo`);
  // }
}
